export default function MedalByAgeGroupTable({ results }) {
  // group by ageGroup
  const grouped = results.reduce((acc, r) => {
    if (!acc[r.ageGroup]) {
      acc[r.ageGroup] = { Gold: 0, Silver: 0, Bronze: 0 };
    }
    if (r.medal === "Gold") acc[r.ageGroup].Gold++;
    if (r.medal === "Silver") acc[r.ageGroup].Silver++;
    if (r.medal === "Bronze") acc[r.ageGroup].Bronze++;
    return acc;
  }, {});

  const ageGroups = Object.keys(grouped);

  if (ageGroups.length === 0) {
    return <p className="text-gray-500">No medal records found for this player.</p>;
  }

  return (
    <div className="p-4 bg-white shadow rounded-xl overflow-x-auto">
      <h1 className="mb-4">Medals by Age Group</h1>
      <table className="min-w-full border border-gray-200 text-center">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 border-b text-left">Age Group</th>
            <th className="px-4 py-2 border-b">🥇 Gold</th>
            <th className="px-4 py-2 border-b">🥈 Silver</th>
            <th className="px-4 py-2 border-b">🥉 Bronze</th>
          </tr>
        </thead>
        <tbody>
          {ageGroups.map((group) => (
            <tr key={group} className="hover:bg-gray-50">
              <td className="px-4 py-2 border-b font-medium text-left">{group}</td>
              <td className="px-4 py-2 border-b">{grouped[group].Gold}</td>
              <td className="px-4 py-2 border-b">{grouped[group].Silver}</td>
              <td className="px-4 py-2 border-b">{grouped[group].Bronze}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
